import { ApplicationUser } from "../../src/entities/ApplicationUser";
import BillingStatement from "../../src/entities/BillingStatement";
import PaymentMethod from "../../src/entities/PaymentMethod";
import Coupon from "../entities/Coupon";
import { WebClient } from "./server/WebClient";

export interface UpdatePaymentMethodRequest {
	paymentMethodId: string;
	expirationMonth: number;
	expirationYear: number;
}

export interface CreateMakerSubscriptionRequest {
	paymentMethodToken: string;
	upgradePath: string;
	isTrial: boolean;
	promoCode: string | null;
	subscriptionType: number;
	bundleWithSc: boolean;
}

export const AccountService = {
	createMakerSubscription: (request: CreateMakerSubscriptionRequest) =>
		WebClient.Post.Validated<ApplicationUser>("api/Account/CreateMakerSubscription", request),

	getBillingStatements: () => WebClient.Get<BillingStatement[]>("api/Account/GetBillingStatements"),

	getPaymentMethod: () => WebClient.Get<PaymentMethod | undefined>("api/Account/GetPaymentMethod"),

	changePaymentMethod: (paymentMethodToken: string) =>
		WebClient.Post.Validated<PaymentMethod>("api/Account/ChangePaymentMethod", { paymentMethodToken }),

	updatePaymentMethod: (updateRequest: UpdatePaymentMethodRequest) =>
		WebClient.Put.Validated<PaymentMethod>("api/Account/UpdatePaymentMethod", updateRequest),

	cancelMakerSubscriptionAtEndOfTerm: () => WebClient.Put.Validated<ApplicationUser>("api/Account/CancelMakerSubscriptionAtEndOfTerm", {}),

	discountMakerSubscription: () => WebClient.Put.Validated<ApplicationUser>("api/Account/DiscountMakerSubscription", {}),

	validatePromoCode: (promoCode: string) => WebClient.Post.Validated<Coupon>("api/Subscription/ValidatePromoCode", { promoCode }),
};
